import { FC } from 'react';
import { useStore, useUnit } from 'effector-react';
import { IconButton } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import ReplyAllRoundedIcon from '@mui/icons-material/ReplyAllRounded';
import i18n from '@shared/config/i18n';
import {
  $currentMessages,
  $selectedMessages,
  changeConfirmDeleteMessagesStatus,
  toggleSelectMode,
} from '../../../models';
import { changeMessagesForForward } from '../../../models/forward-messages/forward-messages.model';
import { useStyles } from './styles';

const { t } = i18n;

export const ChatSelectPanel: FC = () => {
  const selectedMessages = useStore($selectedMessages);
  const [currentMessages] = useUnit([$currentMessages]);
  const selectedLength = selectedMessages.length;
  const classes = useStyles();

  const handleCancelClick = () => {
    toggleSelectMode();
  };

  const handleDeleteClick = () => {
    changeConfirmDeleteMessagesStatus(true);
    //deleteMessages();
  };

  const setMessagesForForward = () => {
    const forwardedMessages = selectedMessages
      .map((selectedId) => currentMessages.find(({ id }) => selectedId === id))
      .filter((message) => !!message);

    changeMessagesForForward(forwardedMessages);
  };

  return (
    <div className={classes.chatSelect}>
      <div className={classes.chatSelect__content}>
        <IconButton size="medium" onClick={handleCancelClick}>
          <CloseRoundedIcon />
        </IconButton>

        <span className={classes.chatSelect__count}>
          {`${t('MessagesSelected')}: ${selectedLength}`}
        </span>

        <div className={classes.chatSelect__actions}>
          <IconButton
            size="medium"
            style={{ transform: 'scale(-1, 1)' }}
            disabled={!selectedLength}
            color="primary"
            onClick={setMessagesForForward}
          >
            <ReplyAllRoundedIcon />
          </IconButton>

          <IconButton
            size="medium"
            color="error"
            disabled={!selectedLength}
            onClick={handleDeleteClick}
          >
            <DeleteOutlineRoundedIcon />
          </IconButton>
        </div>
      </div>
    </div>
  );
};
